"use client";

import { useRouter } from "next/compat/router";
import { useEffect } from "react";
import { usePathname } from "@lib/i18n/navigation-app-router";
import { useCloseUserListManagerElements } from "@hooks/use-userlists";
import AddedToWishlistToast from "./AddedToWishlistToast";
import AddedToUserListToast from "./AddedToUserListToast";
import AddToUserListOffcanvas from "./AddToUserListOffcanvas";
import AuthOffcanvasPriorToLikeProduct from "./AuthOffcanvasPriorToLikeProduct";

function UserListManager() {
  const router = useRouter();
  const pathname = usePathname();
  const closeUserListManagerElements = useCloseUserListManagerElements();

  useEffect(() => {
    if (!router) return;

    function handleRouteChangeStart() {
      closeUserListManagerElements();
    }

    router.events.on("routeChangeStart", handleRouteChangeStart);

    return () => {
      router.events.off("routeChangeStart", handleRouteChangeStart);
    };
  }, [closeUserListManagerElements, router]);

  useEffect(() => {
    if (router) return;

    closeUserListManagerElements(false);
  }, [closeUserListManagerElements, pathname, router]);

  return (
    <>
      <AddedToWishlistToast />
      <AddedToUserListToast />
      <AddToUserListOffcanvas />
      <AuthOffcanvasPriorToLikeProduct />
    </>
  );
}

export default UserListManager;
